import { Component, Input } from '@angular/core';

@Component({
  selector: 'percent-ring',
  templateUrl: './percent-ring.component.html',
  styleUrls: ['./percent-ring.component.less'],
})
export class PercentRingComponent {
  @Input() percent = 0;
  @Input() extraPercent = 0;
  @Input() size = 200;
  @Input() radius = 72;
  @Input() strokeWidth = 16;
  @Input() trackColor = '#F1F5F9';
  @Input() primaryColor = '#00884A';
  @Input() extraColor = '#B8EFC9';

  get center(): number {
    return this.size / 2;
  }

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  get clampedPercent(): number {
    return Math.min(100, Math.max(0, this.percent));
  }

  get clampedExtraPercent(): number {
    return Math.min(100 - this.clampedPercent, Math.max(0, this.extraPercent));
  }

  get primaryLength(): number {
    return (this.clampedPercent / 100) * this.circumference;
  }

  get extraLength(): number {
    return (this.clampedExtraPercent / 100) * this.circumference;
  }

  get primaryDasharray(): string {
    return `${this.primaryLength} ${this.circumference - this.primaryLength}`;
  }

  get extraDasharray(): string {
    return `${this.extraLength} ${this.circumference - this.extraLength}`;
  }

  get extraDashoffset(): number {
    return -this.primaryLength;
  }

  /** Midpoint of the light-green segment as 0–100 scale (for connector alignment). */
  get extraSegmentAnchorPercent(): number {
    return this.clampedPercent + this.clampedExtraPercent / 2;
  }
}
